// Shared wire validation only. A well-shaped report is not an inspector witness,
// a reference authority, or permission to certify/approve a derived candidate.
const keys = (v, names) => v && typeof v === 'object' && !Array.isArray(v)
  && Object.keys(v).length === names.length && names.every(k => Object.hasOwn(v, k));
const ids = ['injection', 'single_shell', 'chrome_transcription', 'links_present', 'css_discipline', 'contamination'];
const missing = 'captured_contamination_policy_unavailable';
const fail = () => { throw Object.assign(Error('esp_document_qa_invalid'), { code: 'esp_document_qa_invalid' }); };

export function validateEspDocumentFloor(value, htmlDigest) {
  if (!keys(value, ['schema', 'status', 'html_sha256', 'checks', 'unavailable_reasons', 'scope', 'full_qa', 'certification'])
    || value.schema !== 'EspDocumentFloor.v1' || !/^[a-f0-9]{64}$/.test(htmlDigest || '') || value.html_sha256 !== htmlDigest
    || value.scope !== 'whole_document_checks' || value.full_qa !== false || value.certification !== 'not_certified'
    || !Array.isArray(value.checks) || value.checks.length !== ids.length
    || !Array.isArray(value.unavailable_reasons) || value.unavailable_reasons.length !== 1 || value.unavailable_reasons[0] !== missing) fail();
  value.checks.forEach((c, i) => {
    if (!keys(c, ['id', 'status', 'code', 'detail']) || c.id !== ids[i]
      || typeof c.detail !== 'string' || !c.detail.length || c.detail.length > 2048 || c.detail.includes('\0')) fail();
    if (c.id === 'contamination') {
      if (c.status !== 'unavailable' || c.code !== missing) fail();
    } else {
      const negative = c.id === 'css_discipline' ? 'warning' : 'failed';
      if (!['passed', negative].includes(c.status) || c.code !== `${c.id}_${c.status}`) fail();
    }
  });
  if (value.status !== (value.checks.some(c => c.status === 'failed') ? 'failed' : 'unavailable')) fail();
  return value;
}
